<template>
  <article class="analysisA"  :class="{hidden: !pageStatus.isLoaded && tabStatus === 'month'}">
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <!-- 昨天、前天/本月、上个月 -->
      <cell :title="selectStore.name" class="top-title">
        <span slot="after-title" class="title-date">|&nbsp;&nbsp;{{this.showDate}}</span>
        <button
          slot="child"
          class="btn-default btn-margin"
          v-for="(item, index) in tabObj[tabStatus]"
          :key="index"
          :class="{'btn-select': period === item.key}"
          @click.stop="selectTab(item.key)"
        >
          {{item.name}}
        </button>
      </cell>

      <component-fans
        :total="fansTotal"
      ></component-fans>

      <chart
        :options="option"
        theme="lineChart"
        auto-resize
        class="mychart"
        v-if="tabList[1].on && tabList[1].id === 'month'"
      ></chart>

    </div>
  </article>
</template>
<script>
// echarts 组件是否加载完毕
import theme from './myLineChart.json'
import util from '../../common/util'
import ComponentFans from './ComponentFans'
import {
  Cell
} from '@lx-frontend/cvux'
let status = {}
status.isLoaded = false
const Chart = () => import(/* webpackChunkName: "ECharts" */ 'vue-echarts').then(ECharts => {
  ECharts.registerTheme('lineChart', theme)
  status.isLoaded = true
  return ECharts
})
export default {
  components: {
    Cell,
    Chart,
    ComponentFans
  },
  data() {
    return {
      pageStatus: status, // 状态信息
      option: {}, // 曲线图数据与设置
      storeId: '', // 参数门店ID
      daysChart: [],
      days: [], // 趋势图X轴刻度
      newFans: [], // 新增关注
      newbound: [], // 新增绑定
      day: util.formatTime(new Date(), 'yyyy-MM-dd'), // 获取当前日期
      fansDaily: {},
      storesDetail: [],
      fansTotal: {},
      selectStore: {}, // 点击跳转进去的门店
      period: '', // 默认日期是今天/本月
      tabStatus: '', // 每日/每月数据
      showDate: '', // 展示当前数据日期or月份
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      // 定义昨日、前天、本月、上个月数据结构
      tabObj: {
        date: [
          {
            key: 'yesterday',
            name: '昨天'
          }, {
            key: 'beforeYesterday',
            name: '前天'
          }
        ],
        month: [
          {
            key: 'this_month',
            name: '本月'
          }, {
            key: 'last_month',
            name: '上个月'
          }
        ]
      }
    }
  },
  created() {
    this.storeId = +this.$route.params.id
    this.day = this.$route.params.date
    let isFlag = this.$route.params.flag === 'true' ? 1 : 0 // true -> 昨天/本月，false -> 前天/上个月
    let isDay = this.$route.params.isDay === 'true' ? 1 : 0 // true -> 每日数据 false -> 每月数据
    // 控制tab切换，日或月点击进来的单店
    if (isDay) {
      this.tabList.forEach((tab) => {
        if (tab.id === 'date') {
          tab.on = true
        } else {
          tab.on = false
        }
      })
    }
    // 控制页面加载进来时默认选中是前天、本月、昨天、上个月四个选项中其中一个
    if (isDay) {
      this.tabStatus = 'date'
      if (isFlag) {
        this.period = 'yesterday'
      } else {
        this.period = 'beforeYesterday'
      }
    } else {
      this.tabStatus = 'month'
      if (isFlag) {
        this.period = 'this_month'
      } else {
        this.period = 'last_month'
      }
    }
    this.queryData(this.day)
  },
  methods: {
    // 获取对应单店信息
    getStoreDetail(data) {
      // 根据上页面传递进来store_id找出特定门店数据
      data.find(vl => {
        if (vl.store_id === this.storeId) {
          this.selectStore = vl
        }
      })
    },
    queryData(chooseDate) {
      let params = {
        date: chooseDate, // this.day,
        store_id: this.storeId ? this.storeId : ''
      }
      let DayOrMonth = ''
      let tabDate = true // 当前选中tab是日数据
      if (this.tabList[0].on && this.tabList[0].id === 'date') {
        DayOrMonth = this.$rest.dataAnalysis.getFansDaily // 调用日数据接口
      } else {
        DayOrMonth = this.$rest.dataAnalysis.getFansMonthly // 调用月数据接口
        tabDate = false
      }
      DayOrMonth(params).then(res => {
        if (res.code === 0) {
          let selectDate = ''
          let dateObj = {}
          this.fansDaily = res.data
          selectDate = Object.keys(this.fansDaily)[0] || ''
          this.showDate = tabDate ? selectDate : selectDate.slice(0, 7) // 日期
          dateObj = Object.values(this.fansDaily)[0]
          this.storesDetail = dateObj.stores_detail
          this.getStoreDetail(this.storesDetail) // 根据store_id找出特定门店数据
          this.fansTotal = dateObj.total
          if (!tabDate) { // 月数据时的折线图数据
            this.daysChart = dateObj.days_detail
            this.cleanChart()
            this.daysChart.forEach(v => {
              let dayX = v.date.replace(/-/g, '/').slice(5)
              this.days.push(dayX)
              this.newFans.push(v.subscribed)
              this.newbound.push(v.bound)
            })
            this.option = this.getEchart(this.days, this.newFans, this.newbound)
          }
        } else {
          this.showToast(res.message)
        }
      })
    },
    // 折线图
    getEchart(time, newFans, newbound) {
      let chartData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        title: {
          text: '趋势图',
          textStyle: {
            color: '#666',
            fontSize: 13,
            fontWeight: 'normal'
          }
        },
        legend: {
          bottom: 10,
          data: [{
            name: '新增关注'
          }, {
            name: '新增绑定'
          }]
        },
        xAxis: {
          type: 'category', // 坐标轴类型
          boundaryGap: false, // 坐标轴两边留白策略
          data: time // this.days
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '新增关注',
          type: 'line',
          data: newFans, // this.newFans,
          markPoint: {
            data: [
              { type: 'max', name: '最大值' }
            ]
          }
        }, {
          name: '新增绑定',
          type: 'line',
          data: newbound // this.newbound
        }]
      }
      return chartData
    },
    onShiftTab (item) {
      if (this.tabStatus === item.id) return false
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true // 月或日被选中
          this.tabStatus = tab.id // 赋值tabStatus当前被选中值
          this.period = tab.id === 'month' ? 'this_month' : 'yesterday' // 转换日/月tab时默认选项今日/本月
          this.selectTab(this.period)
        } else {
          tab.on = false
        }
      })
    },
    // 昨天、前天/本月、上个月切换
    selectTab(key) {
      this.period = key
      switch (key) {
        case 'yesterday':
          let yesterday = new Date(new Date() - 24 * 60 * 60 * 1000)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'beforeYesterday':
          let beforeYesterday = new Date(new Date() - 2 * 24 * 60 * 60 * 1000)
          this.day = util.formatTime(beforeYesterday, 'yyyy-MM-dd')
          break
        case 'this_month':
          this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
          break
        case 'last_month':
          let today = util.formatTime(new Date(), 'yyyy-MM')
          this.day = util.getLastMonth(today) + '-01'
          break
      }
      this.cleanChart()
      this.queryData(this.day)
    },
    cleanChart() {
      this.days = []
      this.newFans = []
      this.newbound = []
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";
</style>
